import { cn } from '@/utils/cn';

type BrandMarkProps = {
  className?: string;
  /** Ink tile behind the mark (nav default). */
  framed?: boolean;
  frameClassName?: string;
  title?: string;
};

/**
 * QuizSecure eye mark. Uses currentColor so it tracks theme / frame contrast.
 */
export function BrandMark({
  className,
  framed = true,
  frameClassName,
  title = 'QuizSecure',
}: BrandMarkProps) {
  const mark = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2048 2048"
      fill="none"
      className={cn(framed ? 'size-5' : 'size-6', className)}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path
        fill="currentColor"
        d="M983.61 1345.26C865.621 1336.17 764.306 1295.86 671.793 1221.76C626.507 1185.85 585.051 1145.36 548.084 1100.94C488.23 1030.23 501.455 1008.02 557.589 939.979C645.307 833.65 761.451 751.265 896.502 718.473C931.735 709.918 961.101 708.683 996.663 705.418C959.519 715.302 931.329 726.579 900.216 750.922C825.993 808.996 779.402 895.079 767.346 988.028C756.084 1074.86 785.428 1167.94 838.513 1236.67C869.71 1277.06 904.247 1307.69 950.293 1330.32C962.103 1336.12 976.345 1342.45 989.461 1344.11L983.61 1345.26Z"
      />
      <path
        fill="currentColor"
        d="M1066.79 706.556C1122 709.087 1169.29 718.639 1221.19 738.267C1226.51 740.278 1246.05 747.763 1249.85 750.413C1250.72 751.265 1254.53 754.172 1254.64 754.665C1254.15 754.78 1252.92 755.085 1252.53 755.259C1252.68 755.829 1263.4 760.897 1264.32 761.103C1265.31 760.545 1266.5 759.582 1267.55 758.932L1267.93 759.061C1269.48 763.985 1264.34 761.66 1271.92 765.323C1280.04 769.247 1275.32 769.287 1282.37 768.151L1282.59 768.353C1282.21 768.933 1281.99 769.265 1281.78 769.903C1282.59 771.692 1284.19 770.369 1285.4 770.228C1286.01 775.062 1287.63 772.372 1289.31 772.638C1289.64 773.251 1290.2 774.799 1291.02 775.073C1295.55 773.535 1294.07 775.598 1294.43 776.706C1296.52 777.714 1302.37 775.982 1301 780.851C1302.78 781.368 1303.04 779.126 1304.18 782.007C1304.85 783.699 1306.33 782.9 1307.26 782.293C1308.9 781.888 1308.27 784.105 1308.24 784.275C1307.93 786.187 1311.84 783.453 1311.54 785.28C1311.42 786.069 1310.37 788.141 1313.43 786.546C1314.23 787.742 1313.07 789.544 1317.48 789.5C1321.42 789.461 1327.85 796.66 1330.13 794.434C1374.18 819.759 1429.47 870.337 1464.78 907.038C1468.29 910.683 1482.11 925.429 1484.26 929.076C1487.26 940.668 1518.41 973.665 1527.25 990.972C1539.08 1014.14 1533.21 1027.33 1538.18 1038.3C1530.1 1066.23 1516.22 1080.29 1498.08 1102.66C1440.89 1173.87 1370.64 1233.52 1291.11 1278.42C1213.82 1321.05 1150.92 1337.61 1064.09 1345.26C1061.59 1344.94 1059.08 1344.63 1056.58 1344.35C1087.43 1339.25 1123.49 1318.42 1147.88 1299.38C1222.42 1241.03 1270.65 1155.39 1281.91 1061.4C1289.41 1055.87 1285.95 1041.36 1286.87 1032.87C1287.52 1026.84 1288.28 991.63 1283.14 988.484L1281.89 987.666C1265.52 863.243 1188.73 745.721 1064.28 708.383C1065.12 707.774 1065.95 707.165 1066.79 706.556Z"
      />
      <path
        fill="currentColor"
        d="M1022.55 916.83C1080.68 915.642 1128.82 961.71 1130.18 1019.84C1131.54 1077.97 1085.62 1126.24 1027.5 1127.77C969.127 1129.32 920.606 1083.15 919.238 1024.78C917.87 966.407 964.176 918.024 1022.55 916.83Z"
      />
    </svg>
  );

  if (!framed) return mark;

  return (
    <div
      className={cn(
        'flex size-9 shrink-0 items-center justify-center rounded-control bg-ink text-parchment sm:size-10',
        frameClassName
      )}
    >
      {mark}
    </div>
  );
}
